import * as Yup from 'yup'

const programSchema = Yup.object().shape({
    title: Yup.string().required('Required'),
})

export { programSchema }
